module.exports = __webpack_public_path__ + "static/rws-account-id-4987506616cfe05a08c39a7f4e2f0952.png";